module.exports = "\n<div (click)=\"toggleLikeState()\">\n    <ion-icon tappable [@bookmark]=\"likeState | async\" [name]=\"iconName\"></ion-icon>\n</div>\n"